import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import '@/assets/css/global.css'
import "@/scss/styles.scss";
import Carousel3d from 'vue-carousel-3d';
import VideoBg from 'vue-videobg'


Vue.config.productionTip = false

Vue.use(Carousel3d);

 
Vue.component('video-bg', VideoBg)

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')


